import React from "react";

const Quote = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
          className="u_fill"
          d="M4.84 28.743C2.993 26.753 2 24.52 2 20.9 2 14.531 6.41 8.822 12.822 6l1.602 2.508C8.44 11.79 7.27 16.05 6.802 18.737c.964-.506 2.226-.683 3.462-.566 3.238.303 5.79 2.998 5.79 6.349 0 1.689-.662 3.309-1.84 4.503a6.237 6.237 0 01-4.441 1.866c-1.926 0-3.767-.892-4.932-2.146zm17.947 0c-1.848-1.99-2.84-4.223-2.84-7.843 0-6.369 4.409-12.078 10.82-14.9l1.604 2.508c-5.986 3.283-7.156 7.543-7.622 10.229.963-.506 2.225-.683 3.462-.566C31.447 18.474 34 21.169 34 24.52c0 1.689-.662 3.309-1.84 4.503a6.237 6.237 0 01-4.441 1.866c-1.926 0-3.767-.892-4.932-2.146z"
          fill={fill}
      />
    </svg>
);

export default Quote;